// extracted by mini-css-extract-plugin
export default {"viewer":"ViewerTeste_viewer__Cbbxt","customViewer":"ViewerTeste_customViewer__ce1bv"};